import { useState } from 'react'

import { cn } from '@/lib/utils'

import { StarIcon } from './StarIcon'
import { useStarsVariants } from '../../Theme'
import { REVIEW_LABELS as LABELS } from '../lib'

interface StarRatingInputProps {
  /** Tailwind size classes of one star (e.g., 'h-12 w-12') */
  starSize: string
  /** Callback when a star is selected, with the rating (1-5) */
  onStarSelect?: (rating: number) => void
  /** Additional container classes */
  className?: string
}

/**
 * StarRatingInput - Click-to-rate input
 *
 * Starts with no star selected. Each star is a button, for mouse and keyboard.
 */
export function StarRatingInput({ starSize, onStarSelect, className }: StarRatingInputProps) {
  const variants = useStarsVariants()
  const [selectedStars, setSelectedStars] = useState(0)

  const selectRating = (rating: number) => {
    setSelectedStars(rating)
    onStarSelect?.(rating)
  }

  return (
    <div
      className={cn(variants.starsContainerVariants({ variant: 'interactive' }), className)}
      role="group"
      aria-label={LABELS.rateProduct}
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <span
          key={i}
          onClick={() => selectRating(i + 1)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              selectRating(i + 1)
            }
          }}
          aria-label={`Acorda ${i + 1} stele`}
          aria-pressed={i < selectedStars}
          className={cn(variants.starIconVariants({ interactive: true }), starSize)}
        >
          <StarIcon filled={i < selectedStars} className="h-full w-full" />
        </span>
      ))}
    </div>
  )
}
